<template>
  <v-container fluid>
    <v-row>
      <v-col xs="12" md="12" sm="12">
        <v-card>
          <v-card-title class="mb-n4">
            Отчет по прослушанным звонкам
          </v-card-title>

          <!-- selectors -->
          <v-form ref="form" lazy-validation v-model="formRules.valid" class="mb-n1">
            <v-card-text>
              <v-row>
                <v-col sm="6" md="4" xl="3" class="col-12 mt-3">
                  <CaruselButton :getVal="getDate" />
                </v-col>

                <v-col sm="6" md="4" xl="3" class="col-12">
                  <ProjectSelector v-model="projects" />
                </v-col>

                <v-col sm="6" md="4" xl="3" class="col-12">
                  <custom-select
                    label="Смены"
                    v-model="shifts"
                    :items="shiftsOptions"
                    multiple
                  />
                </v-col>

                <v-col sm="6" md="4" xl="3" class="col-12">
                  <v-text-field
                      v-model="wiretapping_rate"
                      type="number"
                      max="100"
                      :rules="percentRules"
                      hide-details="auto"
                  >
                    <template slot="label">
                      <div>
                        % прослушки {{ wiretapping_rate === '' ? '(авто)' : '' }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col sm="6" md="4" xl="3" class="col-12">
                  <v-checkbox
                    v-model="operators_only"
                    hide-details
                    label="Операторы"
                  />
                </v-col>

                <v-col xs="12" xl="9" align="right" class="mt-3">
                  <v-btn
                    :disabled="report.without_cache === undefined || report.without_cache || seacrchBtnDisabled"
                    :title="titleForCache"
                    class="mr-1"
                    color="success"
                    @click="loadReport(true)"
                  >
                    <v-icon>mdi-reload</v-icon>
                  </v-btn>

                  <v-btn
                    color="success"
                    width="130px"
                    :disabled="seacrchBtnDisabled"
                    @click="loadReport()"
                  >Поиск</v-btn>
                </v-col>
              </v-row>
            </v-card-text>

          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <!-- total statistic card -->
    <v-card class="mb-4 mt-6" v-if="currentProjects.length > 0">
      <v-card-title>
        <h3 class="mr-5">Всего проектов: {{currentProjects.length}}</h3>
        <v-badge
          class="mr-sm-4 my-2 mb-4"
          bordered
          color="success"
          overlap
         ><v-chip
              class=""
              color="success"
              label
              outlined
              title="Кол-во операторов по которым прослушка выполнена (суммарно по всем проектам) делим на количество операторов на каждом проекте (суммарно по всем проектам)"
          >выполнение прослушки
          </v-chip>
          <template #badge>
            <span v-if="TotalWiretapIsNeeded > 0">{{TotalWiretapIsNeeded}}%</span>
            <v-progress-circular
              v-if="isLoad"
              indeterminate
              color="amber"
              :size="14"
              class="ml-2"
            ></v-progress-circular>
          </template>
        </v-badge>
      </v-card-title>
    </v-card>

    <!-- Accardion -->
    <AccordionStatiz
      :items="getResult"
      :fakeItems="currentProjects"
      noProgress
    >
      <template #title="{item}">
        <h4 style="min-width: 240px;" :title="item.project.name">{{shrinkName(item.project.name)}}</h4>
        <v-tooltip v-for="(badge, index) of item.budges" :key="'badge' + index" bottom max-width="400">
          <template #activator="{ on }">
            <v-badge
              class="my-2 mx-4"
              bordered
              :color="badge.value_color"
              overlap
              :content="badge.value"
            >
              <v-chip
                v-on="on"
                label
                outlined
                :color="badge.title_color"
                style="min-width:174px"
                :style="{ cursor: badge.action ? 'pointer' : 'auto' }"
                @click="badgeClickHandler(badge.action, item)"
              >
                {{ badge.title }}
              </v-chip>
            </v-badge>
          </template>
          <span v-html="badge.hint"></span>
        </v-tooltip>

        <div class="d-flex flex-wrap mt-2">
          <v-card
            v-for="(metric, index) in getMetrics(item.project.id)"
            :key="'metric-' + index"
            class="ma-1"
            outlined
            min-width="160"
          >
            <v-card-subtitle class="pa-2 pb-0 caption">
              <v-tooltip v-if="metric.description" bottom max-width="400">
                <template #activator="{ on }">
                  <span v-on="on" style="cursor: help; border-bottom: 1px dashed currentColor;">
                    {{ metric.label }}
                  </span>
                </template>
                <span>{{ metric.description }}</span>
              </v-tooltip>
              <span v-else>{{ metric.label }}</span>
            </v-card-subtitle>

            <v-card-text class="pa-2 pt-1">
              <v-chip v-if="metric.color" :color="metric.color" small label dark>
                {{ metric.value }}
              </v-chip>
              <span v-else class="font-weight-bold">{{ metric.value }}</span>
            </v-card-text>

            <v-divider />

            <v-card-actions class="pa-1">
              <v-btn x-small text
                :href="$router.resolve({ name: 'complaints-report',
                  query: {
                    project_id: item.project.id,
                    'period[]': [
                      period.start, period.end
                    ],
                    ...metric.query,
                  }}).href"
                target="_blank"
              >
                <v-icon x-small left>mdi-comment-text-outline</v-icon>Отзывы
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </template>

      <template #body="{item: accItem}">
        <v-data-table
            :headers="report.headers"
            :items="accItem.agents"
            :items-per-page="accItem.agents.length"
            :loading="loading"
            loading-text="Загрузка..."
            no-data-text="Ничего не найдено"
            hide-default-footer
            class="mt-5"
        >

          <template #[`item.actions`]="{ item }">
            <v-btn style="color: rgb(144 144 144);"
                  :href="getSpeechAnalysisReportLink(item, accItem.project.name)"
                  target="_blank">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>

          <template v-for="(h, index) in report.headers" #[`header.${h.value}`]>
            <v-tooltip bottom :key="index" v-if="h.caption !== undefined">
              <template #activator="{ on }">
                <span v-on="on">{{ h.text }}</span>
              </template>
              <span>{{ h.caption }}</span>
            </v-tooltip>
            <span v-else :key="index">{{ h.text }}</span>
          </template>

          <template #[`item.wiretapping_rate`]="{ item }">
            {{ `${Number(item.wiretapping_rate * 100).toFixed()}%` }}
          </template>

          <template #[`item.wiretap_is_needed`]="{ item }">
            {{ item.wiretap_is_needed === true ? 'Да' : 'Нет' }}
            <v-icon v-if="item.is_rabbit === true" :title="rabbitIconTitle">mdi-rabbit</v-icon>
            <v-icon color="#b65b5bd4" v-if="item.exclamation_mark" :title="exclamationMarkIconTitle">mdi-space-invaders</v-icon>
          </template>

          <template #[`header.correct_auto_complaints_count`]>
            <v-icon color="success">mdi-check</v-icon>ИИ
          </template>

          <template #[`header.incorrect_auto_complaints_count`]>
            <v-icon color="red">mdi-close</v-icon>ИИ
          </template>
        </v-data-table>

      </template>

      <template #fake_title="{item: projectId}">
        <h4>{{ projectsGetter.find(el => el.id === projectId).name }}</h4>
        <v-progress-circular
          indeterminate
          color="green"
          :size="25"
          class="ml-auto"
        ></v-progress-circular>
      </template>
    </AccordionStatiz>

    <!-- МОДАЛКА СТАТИСТИКИ -->
    <v-dialog v-model="showStatisticModal">


      <v-card class="mt-2">
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Статистика по операторам</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeStatisticModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-progress-linear
          v-if="statisticByOperators.loading"
          indeterminate
          color="green"
        ></v-progress-linear>

        <v-data-table
          v-else
          :headers="statisticByOperators.headers"
          :items="statisticByOperators.data"
          :items-per-page="statisticByOperators.data.length"
          :loading="loading"
          loading-text="Загрузка..."
          no-data-text="Ничего не найдено"
          hide-default-footer
        >
          <template #[`item.listened_percent_relation_to_received_calls`]="{ item }">
            {{ item.listened_percent_relation_to_received_calls }}%
          </template>
          <template #[`item.listened_percent_relation_to_all_listened_calls`]="{ item }">
            {{ item.listened_percent_relation_to_all_listened_calls }}%
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>


  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {requiredRule} from "~/plugins/rules";
import moment from "moment";
import CaruselButton from '~/components/partials/CaruselButton.vue';
import AccordionStatiz from "~/components/partials/AccordionStatiz";
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';
import { axios } from "~/plugins/axios";

export default {
  components: { CaruselButton, AccordionStatiz, ProjectSelector },
  name: "WiretappingRate",
  data() {
    return {
      formRules: {
        valid: false,
        required: requiredRule,
      },
      percentRules: [
        v => !v || (v >= 0 && v <= 100) || 'Допускаются только значения от 0 до 100',
      ],
      projectRules: [
        v => v.length === 1 || 'Item is required',
        v => v !== null || 'Item is required',
      ],
      date: null,
      pickedDate: 'current_month',
      period: {},
      projects: [],
      queues: [],
      report: {
        headers: [
          {
            text: "Фио оператора",
            value: "name",
          },
          {
            text: "Необходимость прослушки",
            caption: '"Да": Если % прослушки оператора ниже целевого  процента прослушки по проекту или КЛН оператора ниже 90%.',
            value: "wiretap_is_needed",
          },
          {
            text: "Количество звонков у оператора",
            value: "calls",
          },
          {
            text: "Колво прослушанных звонков у оператора, шт",
            value: "complaints",
          },
          {
            text: "% прослушки оператора",
            value: "wiretapping_rate",
          },
          {
            text: "Средний КЛН",
            value: "kln_avg",
          },
          {
            text: 'Кол-во офф. жалоб',
            value: 'complaints_official',
          },
          {
            text: 'Кол-во внутренних жалоб',
            value: 'complaints_internal',
          },
          {
            text: 'Кол-во ИИ',
            value: 'auto_complaints_count',
          },
          {
            text: 'ИИ (корректно)',
            value: 'correct_auto_complaints_count',
          },
          {
            text: 'ИИ (некорректно)',
            value: 'incorrect_auto_complaints_count',
          },
          {
            text: 'Просмотр звонков',
            value: 'actions',
            sortable: false
          },
        ],
        items: [],
        projectInfo: {},
        projectWiretapIsNeeded: false,
        month: 'current_month',
      },
      wiretapping_rate: '',
      isLoad: false,
      seacrchBtnDisabled: false,
      currentProjects: [],
      titleForCache: 'Загрузить данные без кеширования. Для ускоренной загрузки звонков, используется кеш, информация в котором обнуляется ежесуточно. Соответственно, если сегодня обновилась информация по звонкам, например были проставлены КЛН, то для получения актуальных данных нужно нажать на эту кнопку. Нажимая на эту кнопку, следует понимать что загрузка информации займёт в разы больше времени чем при обыкновенной загрузке с использованием кеша.',
      operators_only: true,
      stopLoading: false,

      showStatisticModal: false,
      statisticByOperators: {
        loading: true,
        headers: [
          {
            text: 'Имя',
            value: 'author_name',
          },
          {
            text: 'Обработанные вызовы',
            value: 'received_calls_count',
          },
          {
            text: '% прослушанных по отношению к принятым звонкам	',
            value: 'listened_percent_relation_to_received_calls',
          },
          {
            text: '% прослушки от всех прослушанных',
            value: 'listened_percent_relation_to_all_listened_calls',
          },
          {
            text: 'Количество прослушанных звонков',
            value: 'listened_calls_count',
          },
          {
            text: 'Длительность прослушанных звонков, сек.',
            value: 'duration_of_listened_calls_in_seconds',
          },
          {
            text: 'Длительность прослушанных звонков, мин.',
            value: 'duration_of_listened_calls_in_minutes',
          },
        ],
        data: [],
      },

      shifts: [],
      shiftsOptions: [],

      autoComplaintsMetrics: [],
    }
  },

  computed: {
    ...mapGetters({
      hasPermission: 'user/hasPermission',
      projectsGetter: 'graphql/allProjects',
      queuesGetter: 'projects/queues',
      filteredQueues: 'projects/filteredQueues',
      loading: 'shared/getLoading',
      meta: 'shared/meta',
      getResult: 'reports_speech_analysis/getResult',
    }),

    payload() {
      const res = {
        projects: null,
        operators_only: true,
        shifts: this.shifts,
      }

      if (this.shifts.length === 0) delete res.shifts

      return res
    },

    wiretappingRateTitle() {
      // if (this.report.wiretapping_rate !== '') {
      //   return 'Целевой показатель количества прослушанных звонков к их общему количеству';
      // }

      return 'Целевой показатель количества прослушанных звонков к их общему количеству.\n'
          + 'Если прогнозное количество/количество звонков за месяц:\n'
          + '- до 100 звонков за месяц - 25%\n'
          + '- от 101 до 300 звонков - 13%,\n'
          + '- от 301 до 500 зв. - 9%,\n'
          + '- от 501 до 7500 зв. - 4%,\n'
          + '- от 7501 зв. и более - 2.5%.\n'
          + '- от 15001 зв. и более - 1.5%';
    },

    callsCountTitle() {
      if (this.report.month === 'last_month') {
        return 'Всего звонков';
      }

      return 'Кол-во принятых звонков за 28 дней на текущую дату. / 28 дней * 30.42 (среднее количество дней в месяце)';
    },

    rabbitIconTitle() {
      return 'Оператор заслуживающий доверия т.к. выполнены все следующие условия:\n'
          + 'а) % прослушки за выбранный  месяц более 3%\n'
          + 'б) кол-во прослушанных звонков за выбранный месяц более 3 шт.\n'
          + 'в) у оператора за последний месяц КЛН выше 97%\n'
          + 'г) у оператора за 3 последних месяца (в том числе текущем) КЛН выше 97%';
    },

    exclamationMarkIconTitle() {
      return 'Оператор требующий внимания:\n'
          + 'а) у оператора средний КЛН <90\n'
          + 'б) норма прослшки по оператору увеличена на 25% пока выполняется первое условие\n'
    },

    TotalWiretapIsNeeded() {
      if (this.getResult.length === 0) return 0
      let totalWiretapIsNeeded = 0;
      let totalAgents = 0;
      this.getResult.forEach(el => {
        el.agents.forEach(agent =>{
          if (!agent.wiretap_is_needed) totalWiretapIsNeeded++
        })
        totalAgents += el.agents.length
      });
      return Math.round(totalWiretapIsNeeded/totalAgents * 100)
    },
  },

  methods: {
    ...mapActions({
      loadWiretappingRate: 'reports_speech_analysis/loadWiretappingRate',
      loadStatisticByOperators: 'reports_speech_analysis/loadStatisticByOperators',
      setResult: 'reports_speech_analysis/setResult',
      clearResult: 'reports_speech_analysis/clearResult',
      resetAllState: 'resetAllState',
      loadMetrics: 'auto_complaints/loadMetrics',
    }),

    getDate(data) {
      let month = +moment(data.start).format('MM') - 1
      this.date = moment(data.start).format('YYYY-MM-DD')
      this.period = {
        start: moment(data.start).format('YYYY-MM-DD HH:mm:ss'),
        end: moment(data.end).format('YYYY-MM-DD HH:mm:ss')
      }
      this.pickedDate = ((+moment().format('MM') - 1) === month)? 'current_month' : 'last_month';
    },

    getSpeechAnalysisReportLink(item, projName) {
      let proj = this.projectsGetter.find(el => el.name === projName);
      return `/stat/speech-analysis/report?user_id=${item.id}&period[start]=${this.period['start']}&period[end]=${this.period['end']}&project=${proj.id}&call_type=incoming`;
    },

    shrinkName(str) {
      // ToDo переделать в цсс эту дичь
      if (str.length > 17) return str.match(/^.{17}/)[0] + '...'
      else return str
    },

    async openStatisticModal(projectId) {
      this.statisticByOperators.loading = true
      this.showStatisticModal = true

      let payload = {
        period: [
          moment(this.period.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.period.end).format('YYYY-MM-DD HH:mm:ss')
        ],
        projects: [projectId],
      }
      let res = await this.loadStatisticByOperators(payload)
      this.statisticByOperators.data = res
      this.statisticByOperators.loading = false
    },

    closeStatisticModal() {
      this.showStatisticModal = false
      this.statisticByOperators.data = []
    },

    badgeClickHandler(actionName, item) {
      if (actionName === 'open_statistic_modal') this.openStatisticModal(item.project.id)
    },

    getMetrics(projectId) {
      return this.autoComplaintsMetrics.find(el => el.projectId === projectId)?.items || [];
    },


    async loadReport(withoutCache = false) {
      if (this.$refs.form.validate()) {
        this.currentProjects = [];
        this.clearResult();
        this.autoComplaintsMetrics.length = 0;
        this.isLoad = true;
        this.seacrchBtnDisabled = true;
        let date = this.date
        this.payload.date = date

        if (this.operators_only) this.payload.operators_only = true;
        else delete this.payload.operators_only;


        if (withoutCache) {
          this.payload.without_cache = true;
        } else if (this.payload.without_cache !== undefined) {
          delete this.payload.without_cache;
        }
        this.report.month = this.pickedDate;

        let projects = this.projects.slice();
        this.currentProjects = this.projects.slice();

        while (projects.length > 0 && !this.stopLoading) {
          this.loadAutoComplaintsMetrics(projects[0], this.period);

          this.payload.projects = [projects[0]];
          if (this.wiretapping_rate !== '' && !!+this.wiretapping_rate ) {
            this.payload['wiretapping_rate'] = this.wiretapping_rate;
          }
          try {
            let response = await this.loadWiretappingRate(this.payload);
            this.report.without_cache = response.without_cache;
            this.setResult(response);
            projects.shift();
          } catch (err) {
            console.log('ошибочка 8(', err);
            projects.shift();
          }
        }
      }

      this.isLoad = false;
      this.seacrchBtnDisabled = false;
    },

    loadAutoComplaintsMetrics(projectId, { start, end }) {
      this.loadMetrics({ projectId, period: [start, end] })
        .then(items => {
          this.autoComplaintsMetrics.push({projectId, items});
        })
    },
  },

  mounted() {
    this.clearResult();

    axios.get('/api/shifts')
      .then(resp => {
        this.shiftsOptions = resp.data
      })
  },

  beforeDestroy() {
    this.resetAllState();
    this.stopLoading = true;
    this.clearResult();
  },
}
</script>

<style scoped>

</style>